var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"back-button",attrs:{"color":"primary"},on:{"click":_vm.navigateHome}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Packlisten ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }